
import ManufacturingOrderTable from '@/components/mo/ManufacturingOrderTable.vue'
import { FETCH_MANUFACTURING_ORDER_DETAIL } from '@/store/actions'
import { formatQuantityWithUnit } from '@/utils/helpers'
import { getNestedValue } from '@/utils/tableUtils'
import { IManufacturingPlan, IUsePlan } from '@/utils/types/model/manufacturingPlan'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

interface IComponentItemColumn {
  prop: string
  label: string
  formatter?: (row: IUsePlan) => string
}

@Options({
  name: 'ManufacturingPlanDetail',
  components: {
    ManufacturingOrderTable,
  },
})
export default class ManufacturingPlanDetail extends Vue {
  @Prop({ type: String, default: '' }) id!: string
  @Prop({ type: Boolean, default: true }) isShowBackButton!: boolean

  get moID(): string {
    return this.id || (this.$route.params.id as string)
  }

  get mo(): IManufacturingPlan | null {
    return this.$store.getters.getManufacturingOrderDetail || null
  }

  get loading(): boolean {
    return this.$store.getters.isMOLoading || false
  }

  get componentItemColumns(): IComponentItemColumn[] {
    return [
      { prop: 'itemCode', label: this.$t('component_item_code') as string },
      { prop: 'itemName', label: this.$t('component_item_name') as string },
      {
        prop: 'plannedUsageQuantity',
        label: this.$t('planned_usage_quantity') as string,
        formatter: (row: IUsePlan) => formatQuantityWithUnit(row.plannedUsageQuantity, row.stockUnit),
      },
    ]
  }

  getNestedValue(obj: Record<string, unknown>, path: string): unknown {
    return getNestedValue(obj, path)
  }

  getInstructionNo(): string {
    const dateStr = this.mo?.manufactureCompletionDate
    if (!dateStr) return ''
    const formatted = dateStr.slice(0, 10).replace(/-/g, '')
    return `ORNO${this.mo?.orderType}${this.mo?.orderNumber}${this.mo?.projectCode}${this.mo?.companyCode}${formatted}`
  }

  goBack() {
    this.$router.back()
  }

  created() {
    this.$store.dispatch(FETCH_MANUFACTURING_ORDER_DETAIL, this.moID)
  }
}
